module.exports = __webpack_public_path__ + "img/gy.d75d757b.jpeg";